import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

i18n
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options

  .init({
    react: {
      useSuspense: false,
    },
    debug: process.env.NODE_ENV === 'development' ?? false,
    fallbackLng: 'ng',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, rawFormat, lng) => {
        let options = {
          // weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          //  timeZoneName: 'short',
          hour: 'numeric',
          hour12: true,
          timeZone: 'GMT',
          minute: 'numeric',
          //second: '2-digit',
        };

        const getLocale = (lng = 'en-NG') => {
          switch (lng) {
            case 'fr':
              return 'fr-FR';
            default:
              return `${lng}`;
          }
        };

        if (value >= 0) {
          const [format, ...additionalValues] = rawFormat
            .split(',')
            .map(v => v.trim());
          switch (format) {
            case 'uppercase':
              return value.toUpperCase();
            case 'date':
              if (value instanceof Date) {
                //return dayjs(value).format(additionalValues[0]);
                return new Intl.DateTimeFormat(getLocale(lng), options).format(
                  value
                );
              }
              return value.toString();
            case 'currency':
              return Intl.NumberFormat(`${additionalValues[1]}`, {
                style: 'currency',
                currency: additionalValues[0],
                minimumFractionDigits: 0,
              }).format(value);

            default:
              return '';
          }
        }
      },
    },
  });
export default i18n;
